import {v3, quat} from "oc-threejs/short3";
import Maths3 from "oc-threejs/Maths3";
import Segmente from "./Segmente";

/**
 * Dient erstmal nur als Dummy-Beispiel für D&Drop
 */
export default class Garderobenlift extends Segmente {

    constructor(vsData) {
        super(vsData);
        this.parts = [
            {
                obj: 'Model/805.20.324_440-610_HAENGESTANGE.obj',
                origin: v3(0.5, 1, 0.7),
                quaternion: quat(0, 1, 0, 270),
                scale: v3(100, 100, 100),
                fitin: {
                    origin: [0, 0.5],
                    offset: [1, 0],
                    point: [0, 0.5]
                }
            },
            {
                obj: 'Model/805.20.324_440-610_LINKS.obj',
                origin: v3(0, 0, 0.5),
                quaternion: quat(0, 1, 0, 270),
                scale: v3(-100, 100, -100),
            },
            {
                obj: 'Model/805.20.324_440-610_RECHTS.obj',
                origin: v3(1, 0, 0.5),
                quaternion: quat(0, 1, 0, 270),
                scale: v3(-100, 100, -100),
            },
            {
                obj: 'Model/805.20.324_440-610_ZUGSTANGE.obj',
                origin: v3(0.5, 1.35, 0.75),
                quaternion: quat(0, 1, 0, 270),
                scale: v3(-100, 100, 100),
            }
        ];
    }
}
